import React from 'react';

import {
  ListItemButton as MuiListItemButton,
  ListItemButtonProps as MuiListItemButtonProps,
} from '@mui/material';
import { styled } from '@mui/material/styles';

type ExtendedListItemButtonProps = MuiListItemButtonProps &
  React.AnchorHTMLAttributes<HTMLAnchorElement>;

export type ListItemButtonProps = ExtendedListItemButtonProps;

export const ListItemButton: React.ComponentType<ExtendedListItemButtonProps> = styled(
  MuiListItemButton,
)<ExtendedListItemButtonProps>(({ theme }) => ({
  padding: '12px',
  borderRadius: '8px',
  transition: 'background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
  '&:hover': {
    backgroundColor: theme.palette.colors.bg['neutral-secondary'],
  },
  '&.Mui-selected': {
    backgroundColor: theme.palette.colors.bg['neutral-secondary'],
    color: theme.palette.colors.content['inverse-primary'],
    '&:hover': {
      backgroundColor: theme.palette.colors.bg['neutral-secondary'],
    },
    '.MuiListItemText-primary': {
      fontWeight: theme.typography.fontWeightBold,
    },
  },
}));
